module.exports = __webpack_public_path__ + "cba6b7fa0ccb49f5a33ab7ab8d4e7fc1.svg";